// Project configurations
export const projects = {
  wepropel: {
    name: "WePropel",
    agentId: "agent_9201kcj3z5rmfvebw9bq5kf5tyg9"
  },
  
  strive: {
    name: "Strive", 
    agentId: "agent_9201kcj3z5rmfvebw9bq5kf5tyg9"
  },

  testform: {
    name: "60 Decibels Survey",
    agentId: "agent_9201kcj3z5rmfvebw9bq5kf5tyg9",
    formConfig: {
      enabled: true,
      branding: {
        logo: "/60-DB.png",
        primaryColor: "#f97316", // 60 Decibels orange
        backgroundColor: "#0a0a0a" // Dark theme like TimeGlobe
      },
      fields: [
        {
          id: "customer_id",
          label: "Customer ID",
          type: "text",
          required: true,
          placeholder: "Enter your customer ID"
        },
        {
          id: "name",
          label: "Full Name",
          type: "text",
          required: true,
          placeholder: "Enter your full name"
        },
        {
          id: "account_type",
          label: "Account Type",
          type: "select",
          required: true,
          options: ["Basic", "Premium", "Enterprise"]
        }
      ]
    }
  },

  colombia: {
    name: "Colombia WhatsApp Survey",
    agentId: "agent_9201kcj3z5rmfvebw9bq5kf5tyg9", // TODO: replace with the real Colombia agent id
    formConfig: { enabled: false },
    linkTemplate: {
      required: ["respondent_id", "name"],
      uniqueKey: "respondent_id",
      defaults: { tag: "whatsapp" },
      variables: [
        { key: "respondent_id", label: "Respondent ID", required: true },
        { key: "name", label: "Name", required: true },
        { key: "tag", label: "Tag", required: false },
        { key: "phone", label: "Phone", required: false, include: false }
      ],
      suggestedHeaders: {
        respondent_id: ["respondent_id", "respondent id", "respondentid", "id"],
        name: ["name", "full_name", "full name", "customer_name", "customer name"],
        tag: ["tag", "source"],
        phone: ["phone", "phone_number", "phone number", "whatsapp", "msisdn", "mobile"]
      }
    }
  }
};

export const getProjectConfig = (projectId) => {
  return projects[projectId] || null;
};

export const getAllProjectIds = () => {
  return Object.keys(projects);
};
